module.exports = __webpack_public_path__ + "static/media/forureining.b38200ed.m4a";